import { NSValidation } from './../../classes/NSValidation';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
declare var bootbox:any;
@Component({
  selector: 'app-category-ne',
  template: require('./category-ne.component.html')
})
export class CategoryNeComponent extends BaseComponent implements OnInit {

  public categoryId = -1;
  public category = {name:"",description:null};

  ngOnInit() {
    super.ngOnInit();
  }

  public routeParamsUpdated() {
    this.categoryId = this.default(this.currentRouteParams["catId"],-1);
    if(this.categoryId>0)
      this.loadCategoryById();
    else 
      this.categoryId = -1;
  }

  public loadCategoryById() {
      this.busy = this.lsApi.getCategoryById(this.categoryId).subscribe(resp => {
        if(resp.status) {
            this.category = resp.data[0];
        }
    },
    error => {
        console.log(error);
    });
  }

  public save() {
    var validate:NSValidation = new NSValidation();

    var errorMessage = "";
    if(validate.isEmpty(this.category.name)) {
        errorMessage = "Please provide a name for this category";
    }

    if(this.category.description == "null" || this.category.description == null ) {
      this.category.description = null;
    }

    if(errorMessage!="") {
        bootbox.alert(errorMessage);
    }
    else {
        this.busy = this.lsApi.saveCategory(this.categoryId, this.category.name, this.category.description).subscribe(resp => {
            if(resp.status) {
                this.router.navigate(['/admin/categories']).then(() => {
                  this.appToast.success("Category Successfully Saved","Category Saved")
                })
            }
        },
        error => {
            console.log(error);
        });
    }
  }

  public cancel() {
    this.router.navigate(['/admin/categories']);
  }

  public delete() {

    bootbox.confirm({message:"Do you want to delete '" + this.category.name + "' category and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteCategoryById(this.categoryId).subscribe(resp => {
              if(resp.status) {
                  this.router.navigate(['/admin/categories']).then(() => {
                    this.appToast.success("Category Successfully Deleted","Category Deleted")
                  })
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/category-ne/category-ne.component.ts